<template>
    <div style="background-color: white;">
        <div class="container" style="background-color: white; height: 1800px;border:15px solid #623e7e">
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marksheet != ''">
                <v-row dense>
                    <div class="row">
                        <div class="col-4" align="right">
                            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="140px"
                                height="140px" alt="logo" />
                        </div>
                        <div class="col-6 pt-8">
                            <span
                                style="text-transform: uppercase;font-weight:bolder;font-size:42px;border-bottom-width: thin; border-bottom-style: outset;">
                                <!-- {{org_basic_data.trust_name}} -->
                                Wisdom World School
                            </span>
                            <br>
                            <span style="text-transform: uppercase;font-weight:bolder;font-size: 28px;">{{ org_basic_data.address }}</span>
                        </div>
                    </div>
                </v-row>
                <center>
                    <span style="font-weight: 900;font-size: 20px;">
                        <strong> Report Card </strong> <br />
                        <strong> Academic Year {{ ay }} </strong><br />
                        <strong> {{ assessment_type }} </strong>
                    </span>
                </center>
                <v-row dense>
                    <v-col class="pl-8" cols="12" sm="3" md="3" style="line-height: 1.2;">
                        <!-- <table style="width: 120%;">
                            <tr>
                                <th align="left" class="pl-2">Name</th>
                                <th>{{ name }}</th>
                            </tr>
                            <tr>
                                <th align="left" class="pl-2">Surname</th>
                                <th>{{ sur_name }}</th>
                            </tr>
                            <tr>
                                <th align="left" class="pl-2">Class</th>
                                <th>{{ standard }}</th>
                            </tr>
                            <tr>
                                <th align="left" class="pl-2">Div</th>
                                <th>{{ div }}</th>
                            </tr>
                            <tr>
                                <th align="left" class="pl-2">Roll No.</th>
                                <th>{{ roll_no }}</th>
                            </tr>
                        </table> -->
                        <table style="width: 150%;">
                            <tr>
                                <th align="left" class="pl-2">Name</th>
                                <th colspan="3" v-if="name_as_on_aadhar_card">{{ name_as_on_aadhar_card }}</th>
                                <th colspan="3" v-else>{{name}} {{ sur_name }}</th>
                            </tr>
                            <tr>
                                <th  align="left" class="pl-2 pr-2">Class -
                               {{ standard }}</th>
                            
                                <th align="left" class="pl-2 pr-2">Div -
                                {{ div }}</th>
                            
                                <th align="left" class="pl-2 pr-2">Roll No. -
                                {{ roll_no }}</th>
                            </tr>
                        </table> 
                    </v-col>
                    <v-col cols="12" class="pr-8" sm="9" md="9" v-if="photo != null" align="right">
                        <img :src="awspath + photo" style="width: 160px; height: 160px;border:2px solid #623e7e"
                            alt="logo" />
                    </v-col>
                    <v-col cols="12" class="pr-8" sm="9" md="9" v-else align="right">
                        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg"
                            style="width: 160px; height: 160px;border:2px solid #623e7e" alt="logo" />
                    </v-col>
                </v-row>
                <!-- {{ leraner_marksheet }} -->
                <v-row dense style="line-height: 1.3;" class="pl-7 pr-7">
                    <v-col cols="12" sm="12" md="12">
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <th colspan="2">
                                        Marks out of 100 <br />
                                        Pass Marks for each subject is 33%
                                    </th>
                                    <th>
                                        Marks Secured
                                    </th>
                                    <th v-if="display_flag_avg == true">
                                        Average
                                    </th>
                                    <th>
                                        Teacher’s Comment
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="s, index in leraner_marksheet" :key="index">
                                    <td colspan="2" v-if="s[0].credit == 0" style="text-transform: uppercase;" class="pl-2">
                                        <strong>
                                            {{ index }}
                                            <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks
                                            }}</span>
                                        </strong>
                                    </td>
                                    <td v-if="s[0].credit != 0" style="text-transform: uppercase;" class="pl-2">
                                        <strong>
                                            {{ index }}
                                            <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks
                                            }}</span>
                                        </strong>
                                    </td>
                                    <td style="width:10%" v-if="s[0].credit != 0 && s[0].count != 0" :rowspan="s[0].count">
                                        <v-row dense>
                                            <span class="avg" style="margin-left: -10px;">
                                                <!-- <strong> }</strong>  :style="{ 'font-size':  s[0].count * 100  + '%' }"  height="50px" width="50px"-->
                                                <img :style="{ 'height': s[0].count * 25 + 'px' }" width="50px"
                                                    src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/close-bracket.png" />
                                            </span>
                                            <span v-if="display_flag_ca == true" class="pt-1"><strong>Cont.<div class=""
                                                        style="line-height: 1;white-space:pre;">Assess.</div>
                                                </strong></span>
                                        </v-row>
                                    </td>
                                    <td>
                                        <center>
                                            <strong>
                                                {{ s[0].marks }}
                                            </strong>
                                        </center>
                                    </td>
                                    <td v-if="s[0].count != 0 && display_flag_avg == true" :rowspan="s[0].count"
                                        class="pb-5">
                                        <strong>
                                            <center>{{ s[0].avg }}</center>
                                        </strong>
                                    </td>
                                    <td v-else-if="s[0].credit == 0 && display_flag_avg == true">

                                    </td>
                                    <td>
                                        <center>
                                            <strong>
                                                {{ s[0].comment }}
                                            </strong>
                                        </center>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pl-2" colspan="2">
                                        <strong>ATTENDANCE</strong>
                                    </td>
                                    <td v-for="(s, index2) in attendance" :key="index2">
                                        <center>
                                            <strong>
                                                {{ s.present }}/{{ s.total_working_stud }} days
                                            </strong>
                                        </center>
                                    </td>
                                    <td v-if="display_flag_avg == true"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="pl-2" colspan="2">
                                        <strong>TOTAL</strong>
                                    </td>
                                    <td>
                                        <span v-if="per_cal">
                                            <center>
                                                <strong>
                                                    {{ obtained_marks }}/{{ totalmarks }}
                                                </strong>
                                            </center>
                                        </span>
                                       <!--  <span v-else>
                                            <center>
                                                <strong> - </strong>
                                            </center>
                                        </span>
                                        <span v-if="hide_percentage_total">
                                            <center>
                                                <strong>
                                                    {{ obtained_marks }}/{{ totalmarks }}
                                                </strong>
                                            </center>
                                        </span> -->
                                        <span v-else>
                                            <center>
                                                <strong> - </strong>
                                            </center>
                                        </span>
                                    </td>
                                    <td v-if="display_flag_avg == true"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="pl-2" colspan="2">
                                        <strong>PERCENTAGE</strong>
                                    </td>
                                    <td>
                                        <span v-if="per_cal">
                                            <center>
                                                <strong>
                                                    {{ percentage }}
                                                </strong>
                                            </center>
                                        </span>
                                        <!-- <span v-else>
                                            <center>
                                                <strong> - </strong>
                                            </center>
                                        </span>
                                        <span v-if="hide_percentage_total">
                                            <center>
                                                <strong>
                                                    {{ obtained_marks }}/{{ totalmarks }}
                                                </strong>
                                            </center>
                                        </span> -->
                                        <span v-else>
                                            <center>
                                                <strong> - </strong>
                                            </center>
                                        </span>
                                    </td>
                                    <td v-if="display_flag_avg == true"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="pl-2" colspan="2">
                                        <strong>TEACHER ISSUING THE REPORT CARD </strong>
                                    </td>
                                    <td>
                                        <center>
                                            <strong>
                                                {{ inst_name }}
                                            </strong>
                                        </center>
                                    </td>
                                    <td v-if="display_flag_avg == true"></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <!-- <v-row dense style="justify-content: flex-start;line-height: 1.5;" v-if="standard_name == 'VIII'">
                    
                </v-row> -->
                <v-row dense >
                    <!-- <v-col cols="12" sm="4" md="4" class="pl-8" v-if="standard_name=='VIII' && grade_details_marathi!=''">
                        <center><strong>MARATHI GRADE KEY</strong></center>
                        <table style="width: 100%;">
                            <tr v-for="g in grade_details_marathi" :key="g.id" v-if="g.gradename != '-'">
                                <th class="pl-10" style="width: 30%; text-align: left;">{{ g.gradename }}</th>
                                <td class="pl-2"><strong>{{ g.graderemark }}</strong></td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" v-else></v-col> -->
                    <v-col cols="12" sm="4" md="4"></v-col>
                    <v-col cols="12" sm="8" md="8" class="pr-8" style="justify-content: flex-end;line-height: 1.5;padding-left: 30%;">
                        <center><strong>GRADE KEY</strong></center>
                        <table style="width: 100%;">
                            <tr v-for="g in grade_details" :key="g.id" v-if="g.gradename != '-'">
                                <th class="pl-10" style="width: 30%; text-align: left;">{{ g.gradename }}</th>
                                <td class="pl-2"><strong>{{ g.graderemark }}</strong></td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
                <br />
                
                <v-row dense justify="center">
                    <strong style="font-size: 17px;">
                        *Disclaimer: For official and legal purposes this report card needs to be authenticated and
                        countersigned by the School authorities.
                    </strong>
                </v-row>
            </v-col>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        org: Number,
    },
    data() {
        return {
            default_value: [],
            dialog_marks: false,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            asd: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            name: null,
            sur_name: null,
            leraner_marksheet: [],
            colspan: null,
            overall_grade: null,
            remark: [],
            org_basic_data: [],
            assessment_type: null,
            grade_details: [],
            inst_name: null,
            percentage: null,
            obtained_marks: null,
            totalmarks: null,
            attendance: null,
            display_flag_avg: null,
            display_flag_ca: null,
            per_cal: null,
            hide_percentage_total: null,
            show_hide_percentage:null,
            grade_details_marathi:[],
            standard_name:null,
            name_as_on_aadhar_card:null,
        };
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        putnull3() {
            this.show = false;
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        getreport() { },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                asd: this.asd,
                org: this.org,
                show_hide_percentage:this.show_hide_percentage
            };
            axios
                .post("/WWSExamination/generatelearnermarksheet", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.roll_no = res.data.roll_no;
                        this.photo = res.data.photo;
                        this.sur_name = res.data.sur_name;
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        this.org_basic_data = res.data.org_basic_data;
                        this.assessment_type = res.data.assessment_type;
                        this.grade_details = res.data.grade_details;
                        this.grade_details_marathi = res.data.grade_details_marathi;
                        this.standard_name = res.data.standard_name
                        this.inst_name = res.data.inst_name;
                        this.percentage = res.data.percentage
                        this.obtained_marks = res.data.obtained_marks
                        this.totalmarks = res.data.totalmarks
                        this.attendance = res.data.attendance
                        this.display_flag_avg = res.data.display_flag_avg
                        this.display_flag_ca = res.data.display_flag_ca
                        this.per_cal = res.data.per_cal
                        this.name_as_on_aadhar_card = res.data.name_as_on_aadhar_card
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.asd = localStorage.getItem("setasd");
        this.registration_no = localStorage.getItem("setreg_no");
        this.show_hide_percentage = localStorage.getItem("show_hide_percentage");
        this.onload();
    },
};
</script>
<style scoped>
.avg {
    font-weight: 100px;
}

table,
th,
td {
    font-size: 20px;
    border: 2px solid black;
    border-collapse: collapse;
    height: 40px;
}

@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .card {
        border: none !important;
    }

    @page {
        /* size: A4 portrait !important;
        margin-top: 0;
        padding-top: none;
        size: 11in 15.5in !important; */

        size: A4;
        margin-top: none;
        padding-top: none;
        size: 13.5in 20.5in; 

        /* size: 13in 18in; */
    }
}
</style>
